import Icon, {
    LoadingOutlined as AntdLoadingOutlined,
    CheckCircleTwoTone as AntdCheckCircleTwoTone,
    CloseOutlined as AntdCloseOutlined,
    QuestionCircleOutlined as AntdQuestionCircleOutlined,
    SearchOutlined as AntdSearchOutlined,
} from '@ant-design/icons';
import { MouseEventHandler } from 'react';

export const LoadingOutlined = (props: any) => <AntdLoadingOutlined {...props} />;

export const CheckCircleTwoTone = (props: any) => <AntdCheckCircleTwoTone {...props} />;

export const CloseOutlined = (props: any) => <AntdCloseOutlined {...props} />;

export const QuestionCircleOutlined = (props: any) => <AntdQuestionCircleOutlined {...props} />;

export const SearchOutlined = (props: any) => <AntdSearchOutlined {...props} />;
interface IProps {
    className?: string;
    onClick?: MouseEventHandler<HTMLSpanElement>;
}

export const DrawerCloseSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="12" fill="white" />
                <path
                    d="M9.86902 7.60937L14.2596 12L9.86902 16.3906"
                    stroke="#9655FF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )}
    />
);

export const ModalCloseSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_143_14090)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.5661 3.13788C12.8265 3.39824 12.8265 3.82037 12.5661 4.08072L8.79492 7.85148L12.5662 11.6232C12.8265 11.8835 12.8265 12.3056 12.5662 12.566C12.3058 12.8263 11.8837 12.8263 11.6233 12.5659L7.85211 8.79429L4.08087 12.5659C3.82052 12.8263 3.39839 12.8263 3.13804 12.566C2.8777 12.3056 2.87768 11.8835 3.13801 11.6232L6.9093 7.85148L3.13811 4.08072C2.87774 3.82037 2.87773 3.39824 3.13809 3.13788C3.39843 2.87754 3.82052 2.87753 4.08087 3.13786L7.85211 6.90867L11.6233 3.13786C11.8837 2.87753 12.3058 2.87754 12.5661 3.13788Z"
                        fill="#1B1B48"
                    />
                </g>
            </svg>
        )}
    />
);

export const SuccessOfToastSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="10" r="10" fill="#8DD25D" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.0452 5.23328C16.4357 5.62384 16.4356 6.25701 16.0451 6.6475L8.54501 14.1461C8.15447 14.5366 7.52133 14.5366 7.13084 14.146L4.13123 11.1462C3.74072 10.7557 3.74075 10.1225 4.13129 9.732C4.52183 9.34149 5.15499 9.34151 5.5455 9.73205L7.83807 12.0248L14.631 5.23315C15.0216 4.84266 15.6547 4.84272 16.0452 5.23328Z"
                    fill="white"
                />
            </svg>
        )}
    />
);

export const WarningOfToastSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="10.0176" r="10" fill="#FF5E5E" />
                <path
                    d="M8.84458 4.80534C8.81215 4.14497 9.33882 3.5918 9.99998 3.5918C10.6611 3.5918 11.1878 4.14497 11.1554 4.80533L10.8025 11.9897C10.7815 12.4176 10.4284 12.7538 9.99998 12.7538C9.57154 12.7538 9.21847 12.4176 9.19745 11.9897L8.84458 4.80534ZM9.99098 13.7258C10.387 13.7258 10.729 13.8518 10.999 14.1038C11.251 14.3558 11.395 14.6798 11.395 15.0758C11.395 15.4718 11.251 15.8138 10.999 16.0658C10.711 16.3178 10.387 16.4438 9.99098 16.4438C9.59498 16.4438 9.27098 16.2998 9.01898 16.0478C8.73098 15.7958 8.60498 15.4718 8.60498 15.0758C8.60498 14.6798 8.73098 14.3558 9.01898 14.1038C9.27098 13.8518 9.59498 13.7258 9.99098 13.7258Z"
                    fill="white"
                />
            </svg>
        )}
    />
);

export const SubjectSearchItemIconSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_ii_203_4166)">
                    <path
                        d="M1.11133 7.77775C1.11133 4.09585 4.0961 1.11108 7.77799 1.11108H12.2224C15.9043 1.11108 18.8891 4.09585 18.8891 7.77775V16.6666C18.8891 17.8939 17.8942 18.8889 16.6669 18.8889H7.77799C4.0961 18.8889 1.11133 15.9041 1.11133 12.2222V7.77775Z"
                        fill="url(#paint0_linear_203_4166)"
                    />
                </g>
                <path
                    d="M7.49984 5.7312C7.4628 5.7312 7.44428 5.80528 7.44428 5.95342V7.17565C7.44428 7.32379 7.4628 7.39787 7.49984 7.39787H5.1665C5.20354 7.39787 5.22206 7.32379 5.22206 7.17565V5.95342C5.22206 5.80528 5.20354 5.7312 5.1665 5.7312H7.49984ZM14.6665 12.9979C14.6665 13.6497 14.5887 14.1312 14.4332 14.4423C14.285 14.7608 14.0109 14.9793 13.6109 15.0979C13.2109 15.2238 12.5998 15.2868 11.7776 15.2868C11.6295 15.2868 11.5554 15.3053 11.5554 15.3423V13.6756C11.5554 13.7127 11.6295 13.7312 11.7776 13.7312C12.148 13.7312 12.4072 13.6793 12.5554 13.5756C12.7035 13.4719 12.7776 13.2645 12.7776 12.9534V7.50898H8.22206C8.07391 7.50898 7.99984 7.5275 7.99984 7.56453V5.7312C7.99984 5.76824 8.07391 5.78676 8.22206 5.78676H14.6665V12.9979ZM7.22206 7.89787C7.18502 7.89787 7.1665 7.97194 7.1665 8.12009V15.0645C7.1665 15.2127 7.18502 15.2868 7.22206 15.2868H5.27761C5.31465 15.2868 5.33317 15.2127 5.33317 15.0645V8.12009C5.33317 7.97194 5.31465 7.89787 5.27761 7.89787H7.22206ZM12.1665 13.1201H7.83317V8.34231H12.1665V13.1201ZM10.4998 11.5645V9.89787H9.49984V11.5645H10.4998Z"
                    fill="white"
                />
                <defs>
                    <filter
                        id="filter0_ii_203_4166"
                        x="-2.88867"
                        y="-2.88892"
                        width="21.7778"
                        height="25.7778"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0.920741 0 0 0 0 1 0 0 0 0 0.405555 0 0 0 0.25 0" />
                        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_203_4166" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dx="-4" dy="-4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.67875 0 0 0 0 0.286111 0 0 0 1 0" />
                        <feBlend mode="normal" in2="effect1_innerShadow_203_4166" result="effect2_innerShadow_203_4166" />
                    </filter>
                    <linearGradient
                        id="paint0_linear_203_4166"
                        x1="0.0316531"
                        y1="1.11108"
                        x2="18.8891"
                        y2="17.6724"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#FFBA61" />
                        <stop offset="1" stopColor="#FCD48B" />
                    </linearGradient>
                </defs>
            </svg>
        )}
    />
);

export const ThumbSvg = ({ className, onClick }: IProps) => (
    <Icon
        className={className}
        onClick={onClick}
        component={() => (
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0424 12.5H6.16504V21.5H20.4283L21.8321 12.5H15.4127L16.2848 10.5H21.8344C22.9389 10.5 23.8344 11.3954 23.8344 12.5C23.8344 12.6017 23.8266 12.7032 23.8112 12.8037L22.4287 21.8037C22.2788 22.7795 21.4392 23.5 20.4519 23.5H6.16504C5.06047 23.5 4.16504 22.6046 4.16504 21.5V12.5C4.16504 11.3954 5.06047 10.5 6.16504 10.5H12.8652L12.0424 12.5Z"
                    fill="#9655FF"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.2303 6.6886C17.0169 7.04799 17.3717 7.99762 17.0213 8.80527L16.2856 10.5H18.4859L18.8575 9.64378C19.7066 7.68734 18.7421 5.36507 16.711 4.67284C14.9305 4.06624 13.0025 5.11706 12.2395 6.87514L10.666 10.5H12.8599L14.1675 7.50214C14.5179 6.6945 15.4437 6.32946 16.2303 6.6886Z"
                    fill="#9655FF"
                />
                <path d="M10.165 14.501H8.16504V19.501H10.165V14.501Z" fill="#9655FF" />
            </svg>
        )}
    />
);

export const ThumbedSvg = ({ className, onClick }: IProps) => (
    <Icon
        className={className}
        onClick={onClick}
        component={() => (
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.0953 12.5234L23.4447 12.5234C24.5493 12.5234 25.4447 13.4189 25.4447 14.5234C25.4447 14.6251 25.437 14.7266 25.4215 14.8271L24.0391 23.8271C23.8892 24.803 23.0496 25.5234 22.0623 25.5234H7.77539C6.67082 25.5234 5.77539 24.628 5.77539 23.5234V14.5234C5.77539 13.4189 6.67082 12.5234 7.77539 12.5234L12.2754 12.5234L13.8488 8.89858C14.6119 7.1405 16.5399 6.08968 18.3204 6.69628C20.3515 7.38851 21.316 9.71078 20.4669 11.6672L20.0953 12.5234ZM9.77614 14.5227H11.7761L12.0733 15.8528C12.5352 17.9211 12.5382 20.0655 12.082 22.135L11.7761 23.5227H9.77614L10.0799 22.1493C10.5375 20.0801 10.536 17.9358 10.0755 15.8673L9.77614 14.5227Z"
                    fill="#9655FF"
                />
            </svg>
        )}
    />
);

export const TreadSvg = ({ className, onClick }: IProps) => (
    <Icon
        className={className}
        onClick={onClick}
        component={() => (
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0424 15.5H6.16504V6.5H20.4283L21.8321 15.5H15.4127L16.2848 17.5H21.8344C22.9389 17.5 23.8344 16.6046 23.8344 15.5C23.8344 15.3983 23.8266 15.2968 23.8112 15.1963L22.4287 6.19635C22.2788 5.22047 21.4392 4.5 20.4519 4.5H6.16504C5.06047 4.5 4.16504 5.39543 4.16504 6.5V15.5C4.16504 16.6046 5.06047 17.5 6.16504 17.5H12.8652L12.0424 15.5Z"
                    fill="#9655FF"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.2293 21.3114C17.0159 20.952 17.3707 20.0024 17.0203 19.1947L16.2891 17.5H18.4849L18.8565 18.3562C19.7057 20.3127 18.7411 22.6349 16.71 23.3272C14.9296 23.9338 13.0015 22.8829 12.2385 21.1249L10.665 17.5H12.8667L14.1665 20.4979C14.5169 21.3055 15.4427 21.6705 16.2293 21.3114Z"
                    fill="#9655FF"
                />
                <path d="M10.165 13.499H8.16504V8.49902H10.165V13.499Z" fill="#9655FF" />
            </svg>
        )}
    />
);

export const TreadedSvg = ({ className, onClick }: IProps) => (
    <Icon
        className={className}
        onClick={onClick}
        component={() => (
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.0953 17.9961L23.4447 17.9961C24.5493 17.9961 25.4447 17.1007 25.4447 15.9961C25.4447 15.8944 25.437 15.7929 25.4215 15.6924L24.0391 6.69244C23.8892 5.71657 23.0496 4.99609 22.0623 4.99609H7.77539C6.67082 4.99609 5.77539 5.89153 5.77539 6.99609V15.9961C5.77539 17.1007 6.67082 17.9961 7.77539 17.9961L12.2754 17.9961L13.8488 21.621C14.6119 23.379 16.5399 24.4299 18.3204 23.8232C20.3515 23.131 21.316 20.8087 20.4669 18.8523L20.0953 17.9961ZM9.77614 15.9968H11.7761L12.0733 14.6667C12.5352 12.5984 12.5382 10.454 12.082 8.38449L11.7761 6.99685H9.77614L10.0799 8.37025C10.5375 10.4394 10.536 12.5837 10.0755 14.6523L9.77614 15.9968Z"
                    fill="#9655FF"
                />
            </svg>
        )}
    />
);

export const FeedbackSvg = ({ className, onClick }: IProps) => (
    <Icon
        className={className}
        onClick={onClick}
        component={() => (
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.5588 3.84961C16.4677 3.84961 17.3225 4.20368 17.9651 4.84608L20.2035 7.08472C20.8463 7.72711 21.2004 8.58191 21.2004 9.49099C21.2004 10.4001 20.8463 11.2547 20.2035 11.8973L12.1509 19.9505L4.40039 20.6496L5.09924 12.8996L13.1525 4.84629C13.7949 4.20368 14.6499 3.84961 15.5588 3.84961ZM6.68296 15.275L6.37629 18.6737L9.77503 18.367L6.68296 15.275ZM14.292 6.52216L7.64852 13.1658L11.884 17.4015L18.5276 10.7578C19.1274 10.1581 19.1274 9.18192 18.5276 8.58217L16.4676 6.52216C15.8679 5.92241 14.8917 5.92241 14.292 6.52216Z"
                    fill="#9655FF"
                />
                <path d="M23.6004 22.1494H4.40039V24.1494H23.6004V22.1494Z" fill="#9655FF" />
            </svg>
        )}
    />
);

export const CopySvg = ({ className, onClick }: IProps) => (
    <Icon
        className={className}
        onClick={onClick}
        component={() => (
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 9.00977H11V7.00977C11 5.9052 11.8954 5.00977 13 5.00977H23C24.1046 5.00977 25 5.9052 25 7.00977V17.0098C25 18.1143 24.1046 19.0098 23 19.0098H21V17.0098H23V7.00977H13V9.00977Z"
                    fill="#9655FF"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 11.0098C18.1046 11.0098 19 11.9052 19 13.0098V23.0098C19 24.1143 18.1046 25.0098 17 25.0098H7C5.89543 25.0098 5 24.1143 5 23.0098V13.0098C5 11.9052 5.89543 11.0098 7 11.0098H17ZM17 13.0098H7V23.0098H17V13.0098Z"
                    fill="#9655FF"
                />
            </svg>
        )}
    />
);

export const OcrEditSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_2076_447)">
                    <path
                        d="M17.5 8.59375V15.5C17.5 16.6046 16.6046 17.5 15.5 17.5H4.5C3.39543 17.5 2.5 16.6046 2.5 15.5V4.5C2.5 3.39543 3.39543 2.5 4.5 2.5H11.4062"
                        stroke="#9655FF"
                        strokeOpacity="0.85"
                        strokeWidth="1.6"
                    />
                    <path
                        d="M16.2862 6.54869L10.3436 12.4857C10.2099 12.6193 10.041 12.7122 9.8566 12.7538L7.46294 13.293C7.24798 13.3414 7.0559 13.1493 7.10436 12.9343L7.64338 10.5432C7.68501 10.3586 7.7782 10.1895 7.91213 10.0557L13.8544 4.11904L16.2862 6.54869ZM17.0404 5.79507L14.6091 3.36542L15.663 2.31205C15.8631 2.11224 16.1342 2 16.4169 2C16.6997 2 16.9708 2.11224 17.1708 2.31205L18.0948 3.23231C18.1939 3.33137 18.2725 3.44898 18.3262 3.57843C18.3798 3.70788 18.4074 3.84662 18.4074 3.98674C18.4074 4.12686 18.3798 4.2656 18.3262 4.39505C18.2725 4.52449 18.1939 4.64211 18.0948 4.74117L17.0404 5.79507Z"
                        fill="#9655FF"
                        fillOpacity="0.85"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_2076_447">
                        <rect width="20" height="20" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        )}
    />
);

export const NewCreateQuestionSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M1.76455 6.49968C1.76455 3.88448 3.8846 1.76443 6.4998 1.76443C9.11501 1.76443 11.2351 3.88448 11.2351 6.49968C11.2351 9.11489 9.11501 11.2349 6.49981 11.2349H3.03314C2.33252 11.2349 1.76455 10.667 1.76455 9.96635V6.49968Z"
                    stroke="#1B1B48"
                    strokeOpacity="0.85"
                    strokeWidth="0.9295"
                />
                <rect x="3.5752" y="6.22253" width="5.57143" height="0.928571" rx="0.464286" fill="#1B1B48" fillOpacity="0.85" />
                <rect
                    x="5.89648"
                    y="9.47253"
                    width="5.57143"
                    height="0.928572"
                    rx="0.464286"
                    transform="rotate(-90 5.89648 9.47253)"
                    fill="#1B1B48"
                    fillOpacity="0.85"
                />
            </svg>
        )}
    />
);

export const KnowledgeSliceVideoIconSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                    x="1.55"
                    y="11.2391"
                    width="8.4"
                    height="10.9"
                    rx="1.95"
                    transform="rotate(-90 1.55 11.2391)"
                    stroke="#9655FF"
                    strokeOpacity="0.45"
                    strokeWidth="1.1"
                    strokeLinecap="round"
                />
                <path
                    d="M8.82874 7.43534L5.74641 9.17515C5.66271 9.2224 5.5669 9.2482 5.46883 9.24991C5.37076 9.25161 5.27397 9.22916 5.18841 9.18485C5.10285 9.14054 5.03161 9.07598 4.98202 8.99781C4.93243 8.91964 4.90627 8.83067 4.90625 8.74007V5.25993C4.90627 5.16933 4.93243 5.08036 4.98202 5.00219C5.03161 4.92402 5.10285 4.85946 5.18841 4.81515C5.27397 4.77084 5.37076 4.74839 5.46883 4.75009C5.5669 4.7518 5.66271 4.7776 5.74641 4.82485L8.82874 6.56466C8.90951 6.61021 8.97625 6.67417 9.02256 6.75041C9.06887 6.82664 9.09319 6.91259 9.09319 7C9.09319 7.08741 9.06887 7.17336 9.02256 7.24959C8.97625 7.32583 8.90951 7.38979 8.82874 7.43534Z"
                    fill="#9655FF"
                />
            </svg>
        )}
    />
);

export const KnowledgeSliceDocumentIconSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="5.3" y1="5.88896" x2="8.7" y2="5.88896" stroke="#9655FF" strokeWidth="1.1" strokeLinecap="round" />
                <line x1="5.3" y1="8.38896" x2="7.2" y2="8.38896" stroke="#9655FF" strokeWidth="1.1" strokeLinecap="round" />
                <path
                    d="M9.69113 3.39627L9.69112 3.39627L9.69322 3.39861L11.0852 4.95299C11.1591 5.03552 11.2 5.14242 11.2 5.2532V10.6863C11.2 11.4871 10.5508 12.1363 9.75 12.1363H4.25C3.44919 12.1363 2.8 11.4871 2.8 10.6863V3.59891C2.8 2.79811 3.44918 2.14892 4.24999 2.14891L8.38419 2.14888C8.51304 2.14888 8.63571 2.20411 8.72113 2.30059L9.69113 3.39627Z"
                    stroke="#9655FF"
                    strokeOpacity="0.45"
                    strokeWidth="1.1"
                    strokeLinecap="round"
                />
            </svg>
        )}
    />
);

export const CollectedKnowledgeSliceVideoIconSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <rect
                    x="1.00006"
                    y="15.3834"
                    width="12.6667"
                    height="16"
                    rx="3.33333"
                    transform="rotate(-90 1.00006 15.3834)"
                    fill="url(#paint0_linear_48_818)"
                />
                <path
                    d="M11.4387 9.57886L7.32889 11.8986C7.2173 11.9616 7.08955 11.996 6.95879 11.9983C6.82803 12.0006 6.69897 11.9706 6.58489 11.9115C6.47081 11.8525 6.37582 11.7664 6.3097 11.6622C6.24358 11.5579 6.20871 11.4393 6.20868 11.3185V6.67832C6.20871 6.55752 6.24358 6.4389 6.3097 6.33467C6.37582 6.23044 6.47081 6.14436 6.58489 6.08528C6.69897 6.0262 6.82803 5.99626 6.95879 5.99853C7.08955 6.00081 7.2173 6.03521 7.32889 6.09821L11.4387 8.41796C11.5464 8.4787 11.6353 8.56398 11.6971 8.66562C11.7588 8.76727 11.7913 8.88186 11.7913 8.99841C11.7913 9.11496 11.7588 9.22956 11.6971 9.3312C11.6353 9.43285 11.5464 9.51813 11.4387 9.57886Z"
                    fill="white"
                />
                <defs>
                    <linearGradient
                        id="paint0_linear_48_818"
                        x1="12.1303"
                        y1="15.3834"
                        x2="-0.518469"
                        y2="26.5624"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#CCD0FF" />
                        <stop offset="1" stopColor="#7D87FF" />
                    </linearGradient>
                </defs>
            </svg>
        )}
    />
);

export const CollectedKnowledgeSliceDocumentIconSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path
                    d="M2.14532 4.51661C2.14532 2.67567 3.63769 1.18329 5.47863 1.18327L10.1463 1.18324C11.1008 1.18323 12.0094 1.59238 12.6421 2.30703L13.4777 3.25089L15.0044 4.95563C15.5519 5.56696 15.8546 6.35875 15.8546 7.17939V13.8499C15.8546 15.6908 14.3622 17.1832 12.5212 17.1832H5.47866C3.63771 17.1832 2.14532 15.6908 2.14532 13.8499V4.51661Z"
                    fill="url(#paint0_linear_46_1542)"
                />
                <line x1="6.54668" y1="7.3744" x2="11.4532" y2="7.3744" stroke="white" strokeWidth="1.58739" strokeLinecap="round" />
                <line x1="6.54675" y1="11.3745" x2="9.2886" y2="11.3745" stroke="white" strokeWidth="1.58739" strokeLinecap="round" />
                <defs>
                    <linearGradient
                        id="paint0_linear_46_1542"
                        x1="15.8289"
                        y1="13.6819"
                        x2="3.64943"
                        y2="0.949067"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#69A5FF" />
                        <stop offset="1" stopColor="#C4DCFF" />
                    </linearGradient>
                </defs>
            </svg>
        )}
    />
);

export const CameraSvg = ({ className }: IProps) => (
    <Icon
        className={className}
        component={() => (
            <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fill="#9655FF"
                    d="M2.90981 3.9552H4.82081C5.32955 3.29625 5.92064 2.53296 5.92889 2.53296H10.0968C10.1066 2.53296 10.704 3.29626 11.218 3.95518H14.8428C15.5398 3.95518 16.1046 4.52624 16.1046 5.23092V12.6695C16.1046 13.3742 15.5398 13.9452 14.8428 13.9452H2.90981C2.21279 13.9452 1.64794 13.3742 1.64794 12.6695V5.2309C1.64794 4.52623 2.21281 3.9552 2.90981 3.9552ZM12.9324 7.1859C13.3293 7.1859 13.6508 6.86089 13.6508 6.46001C13.6508 6.05876 13.3293 5.73373 12.9324 5.73373C12.5359 5.73373 12.2144 6.05876 12.2144 6.46001C12.2144 6.86087 12.5359 7.1859 12.9324 7.1859ZM7.62956 12.1535C9.37469 12.1535 10.8417 10.7142 10.8417 8.93906C10.8417 7.16365 9.37469 5.72469 7.62956 5.72469C5.88479 5.72469 4.48765 7.16364 4.48765 8.93906C4.48765 10.7141 5.88479 12.1535 7.62956 12.1535Z"
                />
            </svg>
        )}
    />
);

export const SubjectSearchSvg = ({ className }: IProps) => (
    <Icon
        className={className}
        component={() => (
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_50_3156)">
                    <rect x="2.39941" y="2.74292" width="10" height="13" rx="1.5" fill="#9655FF" />
                    <line x1="4.88541" y1="8.11435" x2="8.77112" y2="8.11435" stroke="white" strokeWidth="1.25714" strokeLinecap="round" />
                    <line x1="4.88541" y1="10.9715" x2="7.05684" y2="10.9715" stroke="white" strokeWidth="1.25714" strokeLinecap="round" />
                    <path
                        d="M12.1775 1.67438C11.9413 1.03612 11.0386 1.03613 10.8024 1.67438L10.2696 3.11432C10.2623 3.13387 10.2469 3.14928 10.2274 3.15652L8.78742 3.68934C8.14916 3.92552 8.14916 4.82826 8.78742 5.06444L10.2274 5.59727C10.2469 5.6045 10.2623 5.61992 10.2696 5.63947L10.8024 7.0794C11.0386 7.71767 11.9413 7.71766 12.1775 7.0794L12.7103 5.63947C12.7175 5.61992 12.733 5.6045 12.7525 5.59727L14.1924 5.06444C14.8307 4.82826 14.8307 3.92552 14.1924 3.68934L12.7525 3.15652C12.733 3.14928 12.7175 3.13387 12.7103 3.11432L12.1775 1.67438Z"
                        fill="#9655FF"
                        stroke="white"
                    />
                </g>
            </svg>
        )}
    />
);

export const SendSvg = ({ className, onClick }: IProps) => (
    <Icon
        className={className}
        onClick={onClick}
        component={() => (
            <svg width="44" height="28" viewBox="0 0 44 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="44" height="28" rx="14" fill="url(#paint0_linear_84_2668)" />
                <path
                    d="M29.85 8.72496L27.1167 19.6583C26.725 21.2166 25.3917 21.9166 24.225 21.9166H24.2083C23.0333 21.9083 21.6917 21.1916 21.325 19.6166L20.6083 16.575L25.0917 12.0916C25.4167 11.7666 25.4167 11.2333 25.0917 10.9083C24.7667 10.5833 24.2333 10.5833 23.9083 10.9083L19.425 15.3916L16.3833 14.675C14.8083 14.3083 14.0917 12.9666 14.0833 11.8C14.075 10.625 14.775 9.27496 16.3417 8.88329L27.275 6.14996C28 5.96663 28.7583 6.17496 29.2917 6.70829C29.825 7.24163 30.0333 7.99996 29.85 8.72496Z"
                    fill="#F5EFFF"
                    fillOpacity="0.5"
                />
                <path
                    d="M29.3066 6.72335L29.2925 6.70752C29.8258 7.24085 30.0341 7.99919 29.8508 8.72419L28.7341 13.1867L21.5866 20.3367C21.4705 20.108 21.3829 19.8659 21.3258 19.6159L20.6091 16.5742L25.0925 12.0909C25.4125 11.7709 25.4175 11.2492 25.1075 10.9234L29.3066 6.72335Z"
                    fill="#F5EFFF"
                    fillOpacity="0.55"
                />
                <path
                    d="M29.2916 6.70839L29.3066 6.72339L25.1066 10.9234C25.0296 10.8427 24.9373 10.7782 24.835 10.7336C24.7328 10.6891 24.6227 10.6654 24.5112 10.6639C24.3997 10.6624 24.289 10.6832 24.1856 10.725C24.0822 10.7669 23.9882 10.8289 23.9091 10.9076L19.4258 15.3909L16.3841 14.6742C16.149 14.6203 15.9208 14.5394 15.7041 14.4334L22.8924 7.24506L27.2758 6.14923C28.0008 5.96589 28.7591 6.17423 29.2924 6.70756L29.2916 6.70839Z"
                    fill="#F5EFFF"
                />
                <path
                    d="M22.8917 7.24585L15.7042 14.4333C14.6 13.89 14.0908 12.7833 14.0833 11.8C14.075 10.625 14.775 9.27502 16.3417 8.88335L22.8908 7.24585H22.8917Z"
                    fill="white"
                />
                <defs>
                    <linearGradient id="paint0_linear_84_2668" x1="44" y1="24" x2="7.12557" y2="-2.51103" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#9655FF" />
                        <stop offset="1" stopColor="#B38AFE" />
                    </linearGradient>
                </defs>
            </svg>
        )}
    />
);

export const SendDisabledSvg = ({ className }: IProps) => (
    <Icon
        className={className}
        component={() => (
            <svg width="44" height="28" viewBox="0 0 44 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="44" height="28" rx="14" fill="url(#paint0_linear_93_200)" />
                <path
                    d="M29.8502 8.72496L27.1169 19.6583C26.7252 21.2166 25.3919 21.9166 24.2252 21.9166H24.2086C23.0336 21.9083 21.6919 21.1916 21.3252 19.6166L20.6086 16.575L25.0919 12.0916C25.4169 11.7666 25.4169 11.2333 25.0919 10.9083C24.7669 10.5833 24.2336 10.5833 23.9086 10.9083L19.4252 15.3916L16.3836 14.675C14.8086 14.3083 14.0919 12.9666 14.0836 11.8C14.0752 10.625 14.7752 9.27496 16.3419 8.88329L27.2752 6.14996C28.0002 5.96663 28.7586 6.17496 29.2919 6.70829C29.8252 7.24163 30.0336 7.99996 29.8502 8.72496Z"
                    fill="#B2B2B2"
                />
                <path
                    d="M29.3069 6.72335L29.2927 6.70752C29.826 7.24085 30.0344 7.99919 29.851 8.72419L28.7344 13.1867L21.5869 20.3367C21.4708 20.108 21.3832 19.8659 21.326 19.6159L20.6094 16.5742L25.0927 12.0909C25.4127 11.7709 25.4177 11.2492 25.1077 10.9234L29.3069 6.72335Z"
                    fill="#C0C0C0"
                    fillOpacity="0.98"
                />
                <path
                    d="M29.2916 6.70839L29.3066 6.72339L25.1066 10.9234C25.0296 10.8427 24.9373 10.7782 24.835 10.7336C24.7328 10.6891 24.6227 10.6654 24.5112 10.6639C24.3997 10.6624 24.289 10.6832 24.1856 10.725C24.0822 10.7669 23.9882 10.8289 23.9091 10.9076L19.4258 15.3909L16.3841 14.6742C16.149 14.6203 15.9208 14.5394 15.7041 14.4334L22.8924 7.24506L27.2758 6.14923C28.0008 5.96589 28.7591 6.17423 29.2924 6.70756L29.2916 6.70839Z"
                    fill="#CDCDCD"
                />
                <path
                    d="M22.8919 7.24585L15.7044 14.4333C14.6002 13.89 14.0911 12.7833 14.0836 11.8C14.0752 10.625 14.7752 9.27502 16.3419 8.88335L22.8911 7.24585H22.8919Z"
                    fill="#DCDCDC"
                />
                <defs>
                    <linearGradient id="paint0_linear_93_200" x1="44" y1="24" x2="7.12557" y2="-2.51103" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#ECECEC" />
                        <stop offset="1" stopColor="#EFEFEF" />
                    </linearGradient>
                </defs>
            </svg>
        )}
    />
);

export const UploadPictureSvg = ({ className, onClick }: IProps) => (
    <Icon
        className={className}
        onClick={onClick}
        component={() => (
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4.30566" y="6.08337" width="16.0745" height="19.8333" rx="2.50926" stroke="#1B1B48" strokeWidth="1.5" />
                <path
                    d="M4.84033 23.9176L8.95528 19.3712C9.15775 19.1475 9.25898 19.0357 9.37999 18.9892C9.48645 18.9483 9.60307 18.942 9.71333 18.9711C9.83866 19.0042 9.95144 19.1044 10.177 19.3048L13.7717 22.499C13.9998 22.7017 14.1139 22.8031 14.2404 22.836C14.3517 22.8649 14.4693 22.8577 14.5763 22.8156C14.6979 22.7676 14.7989 22.6532 15.0008 22.4243L19.9565 16.8065"
                    stroke="#1B1B48"
                    strokeWidth="1.5"
                    strokeLinecap="square"
                />
                <circle cx="17.7922" cy="13.4093" r="0.75" fill="#1B1B48" stroke="#1B1B48" strokeWidth="0.890124" />
                <path d="M7.54053 12.2142H14.0612M10.8009 8.95496V15.4735" stroke="#1B1B48" strokeWidth="1.5" strokeLinecap="round" />
                <path
                    d="M23.2695 8.88892L24.8378 9.19001L24.8745 9.19707C26.6023 9.52879 27.7548 11.1718 27.4785 12.9093L26.1153 21.4802C25.8492 23.1532 24.2587 24.2798 22.5921 23.9758V23.9758"
                    stroke="#1B1B48"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        )}
    />
);

export const SwiperSwitchLeftSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 16L2 9.36842L9 2" stroke="#9655FF" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9 16L2 9.36842L9 2" stroke="#9655FF" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )}
        onDoubleClick={ev => ev.stopPropagation()}
    />
);

export const SwiperSwitchRightSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 16L9 9.36842L2 2" stroke="#9655FF" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M2 16L9 9.36842L2 2" stroke="#9655FF" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )}
        onDoubleClick={ev => ev.stopPropagation()}
    />
);

export const SwiperAnswerTitleIconSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.13998 18.5C7.29383 18.5 7.44538 18.4594 7.57627 18.3804L10.9311 16.4029H16.557C17.7672 16.4007 18.7477 15.4368 18.75 14.2472V5.65576C18.7477 4.46614 17.7672 3.50226 16.557 3.5H3.44295C2.23281 3.50226 1.2523 4.46614 1.25 5.65576V14.2472C1.2523 15.4368 2.23281 16.4007 3.44295 16.4029H5.68413L6.35465 17.9853C6.44879 18.2088 6.63938 18.3826 6.87361 18.4571C6.96086 18.4865 7.05042 18.5 7.13998 18.5Z"
                    stroke="#9D8AFE"
                    strokeWidth="1.25"
                />
                <path
                    d="M5.01953 11.5449C4.31885 11.5449 3.75 10.9761 3.75 10.2754C3.75 9.57471 4.31885 9.00586 5.01953 9.00586C5.72021 9.00586 6.28906 9.57471 6.28906 10.2754C6.28906 10.9761 5.72021 11.5449 5.01953 11.5449Z"
                    fill="#9D8AFE"
                />
                <path
                    d="M9.79492 11.5449C9.09424 11.5449 8.52539 10.9761 8.52539 10.2754C8.52539 9.57471 9.09424 9.00586 9.79492 9.00586C10.4956 9.00586 11.0645 9.57471 11.0645 10.2754C11.0645 10.9761 10.4956 11.5449 9.79492 11.5449Z"
                    fill="#9D8AFE"
                />
                <path
                    d="M14.5703 11.5449C13.8696 11.5449 13.3008 10.9761 13.3008 10.2754C13.3008 9.57471 13.8672 9.00586 14.5703 9.00586C15.271 9.00586 15.8398 9.57471 15.8398 10.2754C15.8398 10.9761 15.271 11.5449 14.5703 11.5449Z"
                    fill="#9D8AFE"
                />
            </svg>
        )}
    />
);

export const EveryoneIsAskListItemIconSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_ii_242_3623)">
                    <path
                        d="M1.11133 7.77799C1.11133 4.0961 4.0961 1.11133 7.77799 1.11133H12.2224C15.9043 1.11133 18.8891 4.0961 18.8891 7.77799V16.6669C18.8891 17.8942 17.8942 18.8891 16.6669 18.8891H7.77799C4.0961 18.8891 1.11133 15.9043 1.11133 12.2224V7.77799Z"
                        fill="url(#paint0_linear_242_3623)"
                    />
                </g>
                <path
                    d="M7.50033 5.73145C7.46329 5.73145 7.44477 5.80552 7.44477 5.95367V7.17589C7.44477 7.32404 7.46329 7.39811 7.50033 7.39811H5.16699C5.20403 7.39811 5.22255 7.32404 5.22255 7.17589V5.95367C5.22255 5.80552 5.20403 5.73145 5.16699 5.73145H7.50033ZM14.667 12.9981C14.667 13.65 14.5892 14.1314 14.4337 14.4426C14.2855 14.7611 14.0114 14.9796 13.6114 15.0981C13.2114 15.224 12.6003 15.287 11.7781 15.287C11.63 15.287 11.5559 15.3055 11.5559 15.3426V13.6759C11.5559 13.7129 11.63 13.7314 11.7781 13.7314C12.1485 13.7314 12.4077 13.6796 12.5559 13.5759C12.704 13.4722 12.7781 13.2648 12.7781 12.9537V7.50922H8.22255C8.0744 7.50922 8.00033 7.52774 8.00033 7.56478V5.73145C8.00033 5.76848 8.0744 5.787 8.22255 5.787H14.667V12.9981ZM7.22255 7.89811C7.18551 7.89811 7.16699 7.97219 7.16699 8.12033V15.0648C7.16699 15.2129 7.18551 15.287 7.22255 15.287H5.2781C5.31514 15.287 5.33366 15.2129 5.33366 15.0648V8.12033C5.33366 7.97219 5.31514 7.89811 5.2781 7.89811H7.22255ZM12.167 13.1203H7.83366V8.34256H12.167V13.1203ZM10.5003 11.5648V9.89811H9.50033V11.5648H10.5003Z"
                    fill="white"
                />
                <defs>
                    <filter
                        id="filter0_ii_242_3623"
                        x="-2.88867"
                        y="-2.88867"
                        width="21.7773"
                        height="25.7773"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0.920741 0 0 0 0 1 0 0 0 0 0.405555 0 0 0 0.25 0" />
                        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_242_3623" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dx="-4" dy="-4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.67875 0 0 0 0 0.286111 0 0 0 1 0" />
                        <feBlend mode="normal" in2="effect1_innerShadow_242_3623" result="effect2_innerShadow_242_3623" />
                    </filter>
                    <linearGradient
                        id="paint0_linear_242_3623"
                        x1="0.0316531"
                        y1="1.11133"
                        x2="18.8891"
                        y2="17.6727"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#FFBA61" />
                        <stop offset="1" stopColor="#FCD48B" />
                    </linearGradient>
                </defs>
            </svg>
        )}
    />
);

export const LoadMoreIconSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.2389 2.96192C9.23888 3.0893 9.26395 3.21544 9.31269 3.33312C9.36142 3.45081 9.43286 3.55774 9.52292 3.64782C9.61298 3.7379 9.71991 3.80935 9.83759 3.8581C9.95527 3.90685 10.0814 3.93194 10.2088 3.93194C10.3362 3.93194 10.4623 3.90685 10.58 3.8581C10.6976 3.80935 10.8046 3.7379 10.8946 3.64782C10.9847 3.55774 11.0561 3.45081 11.1049 3.33312C11.1536 3.21544 11.1787 3.0893 11.1787 2.96192C11.1786 2.70472 11.0764 2.45806 10.8945 2.27621C10.7126 2.09435 10.466 1.99219 10.2088 1.99219C9.95157 1.99219 9.7049 2.09435 9.52302 2.27621C9.34114 2.45806 9.23893 2.70472 9.2389 2.96192ZM10.2088 11.2085C10.3363 11.2085 10.4625 11.1834 10.5802 11.1345C10.698 11.0857 10.805 11.0142 10.895 10.924C10.9851 10.8338 11.0565 10.7267 11.1052 10.6089C11.1539 10.491 11.1788 10.3648 11.1787 10.2373V6.84273C11.1787 6.71536 11.1536 6.58922 11.1049 6.47154C11.0561 6.35385 10.9847 6.24691 10.8946 6.15684C10.8046 6.06676 10.6976 5.99531 10.58 5.94656C10.4623 5.89781 10.3362 5.87272 10.2088 5.87272C10.0814 5.87272 9.95527 5.89781 9.83759 5.94656C9.71991 5.99531 9.61298 6.06676 9.52292 6.15684C9.43286 6.24691 9.36142 6.35385 9.31269 6.47154C9.26395 6.58922 9.23888 6.71536 9.2389 6.84273V10.2373C9.2389 10.7731 9.673 11.2085 10.2088 11.2085ZM9.68342 18.8019C9.75264 18.8675 9.83606 18.9162 9.92718 18.9443C10.0183 18.9723 10.1147 18.9789 10.2088 18.9636C10.3029 18.9789 10.3992 18.9723 10.4904 18.9443C10.5815 18.9162 10.6649 18.8675 10.7341 18.8019L16.835 12.6229C17.1139 12.3387 17.0305 11.7951 16.6485 11.4079C16.2666 11.0208 15.7295 10.936 15.4492 11.2189L10.2088 16.5285L4.96831 11.2189C4.68934 10.936 4.15226 11.0195 3.769 11.4079C3.38705 11.7951 3.30362 12.3387 3.58389 12.6216L9.68342 18.8019Z"
                    fill="white"
                />
            </svg>
        )}
    />
);

export const TabMoreIconSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 14L15.7368 19L21 14" stroke="#9655FF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )}
    />
);

export const LcuaTitleIcon = () => (
    <Icon
        component={() => (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M7.19048 0H11L4.80952 20H1L7.19048 0Z" fill="#867EF5" fillOpacity="0.6" />
                <path d="M14.1905 0H18L11.8095 20H8L14.1905 0Z" fill="#867EF5" fillOpacity="0.37" />
            </svg>
        )}
    />
);

export const MessageTipIcon = (props: any) => (
    <Icon
        {...props}
        component={() => (
            <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none">
                <circle cx="24.5" cy="24.5" r="23.5" fill="url(#paint0_linear_695_143)" stroke="white" strokeWidth="2" />
                <path
                    d="M24.3707 13.5955L18.0681 17.6432H14.9239C13.1767 17.6432 11.7607 19.0418 11.7607 20.7937V27.1074C11.7607 28.8482 13.1594 30.2579 14.9239 30.2579H18.0681L24.3707 34.3025C25.2616 34.6888 25.9522 34.2757 25.9522 33.3989V14.499C25.9522 13.6207 25.2442 13.2186 24.3707 13.5955ZM29.6815 18.6823C29.385 18.3638 28.8852 18.3465 28.5682 18.6445C28.2497 18.9425 28.2339 19.4408 28.5304 19.7593C28.677 19.917 28.9277 20.2655 29.1863 20.7921C29.6279 21.6909 29.8944 22.7458 29.8944 23.9506C29.8944 25.1553 29.6279 26.2117 29.1863 27.109C28.9277 27.6356 28.677 27.9841 28.5304 28.1418C28.2324 28.4603 28.2497 28.9586 28.5682 29.2566C28.8868 29.5547 29.385 29.5373 29.6831 29.2188C29.9306 28.9539 30.2712 28.4808 30.6024 27.8044C31.1464 26.6974 31.4712 25.4076 31.4712 23.949C31.4712 22.4904 31.1464 21.2006 30.6024 20.0936C30.2696 19.4203 29.929 18.9456 29.6815 18.6823ZM34.516 17.7063C33.879 16.6277 33.2356 15.8803 32.7847 15.4782C32.4598 15.1881 31.9616 15.2165 31.6714 15.5429C31.3813 15.8693 31.4096 16.366 31.7361 16.6561C31.8102 16.7223 31.9584 16.8705 32.1571 17.1007C32.4977 17.4949 32.8382 17.9649 33.1584 18.5073C34.0745 20.0621 34.6248 21.8801 34.6248 23.9505C34.6248 26.0209 34.0745 27.839 33.1568 29.3954C32.8367 29.9378 32.4945 30.4077 32.1555 30.8019C31.9568 31.0321 31.8086 31.1803 31.7345 31.2465C31.4096 31.5367 31.3813 32.0349 31.6698 32.3598C31.9584 32.6846 32.4583 32.713 32.7831 32.4244C33.2341 32.0224 33.8774 31.2765 34.5145 30.1964C35.5678 28.4098 36.2001 26.3205 36.2001 23.9505C36.2017 21.5822 35.5694 19.4928 34.516 17.7063Z"
                    fill="#8F5202"
                />
                <defs>
                    <linearGradient id="paint0_linear_695_143" x1="24.5" y1="0" x2="24.5" y2="49" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#FFD588" />
                        <stop offset="1" stopColor="#FFDECB" />
                    </linearGradient>
                </defs>
            </svg>
        )}
    />
);

export const MessageArrow = (props: any) => (
    <Icon
        {...props}
        component={() => (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect width="24" height="24" rx="12" fill="white" fillOpacity="0.42" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.87174 16.3907L13.1144 12.148L8.87174 7.9054L9.81455 6.9626L15 12.148L9.81455 17.3335L8.87174 16.3907Z"
                    fill="#79808B"
                />
            </svg>
        )}
    />
);

export const SolveTipIcon = (props: any) => (
    <Icon
        {...props}
        component={() => (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <circle cx="10" cy="10" r="10" fill="#B9BFFF" />
                <path
                    d="M5 10.6316L8.96 14L16 6"
                    stroke="#5060FF"
                    strokeOpacity="0.6"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )}
    />
);

export const AnswerIcon = () => (
    <Icon
        component={() => (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_ii_203_9385)">
                    <path
                        d="M1.11133 7.77799C1.11133 4.0961 4.0961 1.11133 7.77799 1.11133H12.2224C15.9043 1.11133 18.8891 4.0961 18.8891 7.77799V16.6669C18.8891 17.8942 17.8942 18.8891 16.6669 18.8891H7.77799C4.0961 18.8891 1.11133 15.9043 1.11133 12.2224V7.77799Z"
                        fill="url(#paint0_linear_203_9385)"
                    />
                </g>
                <path
                    d="M7.49984 5.73096C7.4628 5.73096 7.44428 5.80503 7.44428 5.95318V7.1754C7.44428 7.32355 7.4628 7.39762 7.49984 7.39762H5.1665C5.20354 7.39762 5.22206 7.32355 5.22206 7.1754V5.95318C5.22206 5.80503 5.20354 5.73096 5.1665 5.73096H7.49984ZM14.6665 12.9976C14.6665 13.6495 14.5887 14.131 14.4332 14.4421C14.285 14.7606 14.0109 14.9791 13.6109 15.0976C13.2109 15.2235 12.5998 15.2865 11.7776 15.2865C11.6295 15.2865 11.5554 15.305 11.5554 15.3421V13.6754C11.5554 13.7124 11.6295 13.731 11.7776 13.731C12.148 13.731 12.4072 13.6791 12.5554 13.5754C12.7035 13.4717 12.7776 13.2643 12.7776 12.9532V7.50873H8.22206C8.07391 7.50873 7.99984 7.52725 7.99984 7.56429V5.73096C7.99984 5.76799 8.07391 5.78651 8.22206 5.78651H14.6665V12.9976ZM7.22206 7.89762C7.18502 7.89762 7.1665 7.9717 7.1665 8.11985V15.0643C7.1665 15.2124 7.18502 15.2865 7.22206 15.2865H5.27761C5.31465 15.2865 5.33317 15.2124 5.33317 15.0643V8.11985C5.33317 7.9717 5.31465 7.89762 5.27761 7.89762H7.22206ZM12.1665 13.1198H7.83317V8.34207H12.1665V13.1198ZM10.4998 11.5643V9.89762H9.49984V11.5643H10.4998Z"
                    fill="white"
                />
                <defs>
                    <filter
                        id="filter0_ii_203_9385"
                        x="-2.88867"
                        y="-2.88867"
                        width="21.7778"
                        height="25.7778"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0.920741 0 0 0 0 1 0 0 0 0 0.405555 0 0 0 0.25 0" />
                        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_203_9385" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dx="-4" dy="-4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.67875 0 0 0 0 0.286111 0 0 0 1 0" />
                        <feBlend mode="normal" in2="effect1_innerShadow_203_9385" result="effect2_innerShadow_203_9385" />
                    </filter>
                    <linearGradient
                        id="paint0_linear_203_9385"
                        x1="0.0316531"
                        y1="1.11133"
                        x2="18.8891"
                        y2="17.6727"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#FFBA61" />
                        <stop offset="1" stopColor="#FCD48B" />
                    </linearGradient>
                </defs>
            </svg>
        )}
    />
);

export const WarningIcon = (props: any) => (
    <Icon
        {...props}
        component={() => (
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0ZM7.66667 9.33333H6.33333V10.6667H7.66667V9.33333ZM7.66667 3.66667H6.33333V8.66667H7.66667V3.66667Z"
                    fill="#FF7242"
                />
            </svg>
        )}
    />
);

export const SubjectArrowIcon = () => (
    <Icon
        component={() => (
            <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M0.695025 1.87291L4.54371 5.80749C4.60181 5.86859 4.67235 5.91727 4.75085 5.95041C4.82935 5.98355 4.91409 6.00044 4.99967 5.99999C5.085 6.00023 5.16945 5.98325 5.24768 5.95011C5.32591 5.91698 5.39621 5.86841 5.45414 5.80749L9.30432 1.87291C9.39607 1.78394 9.45913 1.67088 9.48577 1.54758C9.51241 1.42428 9.50148 1.2961 9.45431 1.17875C9.40439 1.05951 9.32121 0.956193 9.21415 0.880441C9.10709 0.804689 8.9804 0.759512 8.84836 0.75H1.15399C1.02175 0.758789 0.894701 0.803499 0.78731 0.87904C0.679918 0.954581 0.596496 1.05792 0.546537 1.17729C0.49886 1.29469 0.487515 1.42308 0.513896 1.54667C0.540277 1.67026 0.603235 1.78366 0.695025 1.87291Z"
                    fill="#BAC0FF"
                />
            </svg>
        )}
    />
);

export const MyCollectIcon = () => (
    <Icon
        component={() => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.90074 7.95585C6.13303 7.98667 5.4587 8.50042 5.24084 9.22994L3.26972 18.1178C2.56426 17.7992 2.11816 17.1005 2.11816 16.3402V5.98306C2.11816 4.89392 3.01036 4.01027 4.11004 4H7.91742C8.32202 4.01027 8.6955 4.25687 8.84074 4.62677L9.58769 5.98306H17.0676C18.1673 5.98306 19.0595 6.8667 19.0595 7.95585H6.90074ZM7.76802 9.17746H20.1072C21.3494 9.17746 22.2086 10.5598 21.7635 11.8501L19.569 18.7313C19.3516 19.4583 18.6787 19.9703 17.9127 20.0011H6.34388C5.14051 20.0011 4.24616 18.8874 4.50588 17.7124L6.11175 10.4472C6.32914 9.70993 7.002 9.19794 7.76802 9.17746ZM14.7451 15.4545L16.0183 14.2155C16.1115 14.1541 16.1736 14.0517 16.1736 13.9493C16.1736 13.7547 16.0183 13.6011 15.832 13.6011L14.0619 13.3451L13.2648 11.7477C13.2337 11.6555 13.1509 11.5736 13.0577 11.5429C12.8818 11.4814 12.6851 11.5736 12.623 11.7477L11.8259 13.3451L10.0557 13.6011C9.94188 13.6011 9.83836 13.6523 9.77625 13.7445C9.66238 13.8981 9.70379 14.1029 9.85907 14.2155L11.1323 15.4648L10.8321 17.2158C10.7907 17.3592 10.8425 17.5025 10.9563 17.5947C11.0702 17.6766 11.2358 17.6766 11.3601 17.5947L12.9335 16.7652L14.507 17.5844C14.5691 17.6254 14.6519 17.6459 14.7244 17.6459C14.7968 17.6561 14.8693 17.6356 14.921 17.5844C15.0246 17.4923 15.0763 17.3489 15.0453 17.2056L14.7451 15.4545Z"
                    fill="#AEB7FF"
                />
            </svg>
        )}
    />
);

export const HaveCollectIcon = (props: any) => (
    <Icon
        {...props}
        component={() => (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.7888 2.75807C10.9163 2.84929 11.0271 2.96149 11.1166 3.08984L13.0365 5.844C13.1307 5.97907 13.2705 6.07601 13.4305 6.11716L16.4665 6.89824C16.6845 6.95431 16.8854 7.06264 17.0516 7.21376C17.2179 7.36487 17.3443 7.55416 17.4199 7.76509C17.4956 7.97602 17.5181 8.20216 17.4855 8.42374C17.4529 8.64532 17.3663 8.8556 17.2331 9.03618L15.1984 11.7945C15.11 11.9143 15.0632 12.0595 15.065 12.2081L15.1029 15.2564C15.1056 15.473 15.0567 15.6872 14.96 15.8813C14.8634 16.0755 14.7219 16.2441 14.5471 16.3734C14.3723 16.5027 14.1691 16.589 13.9543 16.6251C13.7395 16.6612 13.5191 16.6462 13.3112 16.5813L10.2084 15.6125C10.0756 15.5709 9.93333 15.5703 9.80024 15.6107L6.52364 16.6067C6.3175 16.6694 6.09946 16.6832 5.88701 16.6469C5.67455 16.6106 5.47362 16.5253 5.30033 16.3978C5.12703 16.2704 4.98622 16.1042 4.88919 15.9129C4.79215 15.7215 4.74161 15.5101 4.7416 15.2958V12.1872C4.74167 12.0516 4.70124 11.9189 4.62544 11.8061L2.73276 8.99334C2.61101 8.81237 2.53436 8.60516 2.50916 8.38888C2.48396 8.1726 2.51093 7.95346 2.58784 7.7496C2.66475 7.54574 2.78938 7.36303 2.95143 7.21659C3.11347 7.07015 3.30827 6.96419 3.51969 6.90749L6.46918 6.11682C6.62228 6.07569 6.75643 5.98333 6.84902 5.85531L8.86441 3.0703C9.07796 2.77516 9.40068 2.57645 9.76158 2.5179C10.1225 2.45935 10.492 2.54574 10.7888 2.75807ZM12.2641 10.2947C11.727 10.8993 11.0015 11.1995 10.0339 11.1995C9.05744 11.1995 8.2843 10.8917 7.67179 10.269C7.54338 10.1418 7.36976 10.07 7.1885 10.0691C7.00724 10.0683 6.83294 10.1384 6.70333 10.2644C6.57372 10.3904 6.49923 10.5621 6.49598 10.7423C6.49274 10.9225 6.561 11.0967 6.68599 11.2272C7.56425 12.1204 8.69448 12.5707 10.0343 12.5707C11.3834 12.5707 12.4885 12.1129 13.2974 11.2015C13.4147 11.0647 13.4732 10.8876 13.4604 10.7083C13.4476 10.529 13.3644 10.3618 13.2289 10.2429C13.0933 10.124 12.9162 10.0628 12.7356 10.0724C12.5551 10.0821 12.3856 10.1619 12.2637 10.2947H12.2641Z"
                    fill="#AEB7FF"
                />
            </svg>
        )}
    />
);

export const NotCollectIcon = (props: any) => (
    <Icon
        {...props}
        component={() => (
            <svg version="1.2" baseProfile="tiny" id="图层_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 20 20">
                <g>
                    <g>
                        <path
                            fill="#AEB7FF"
                            d="M10,13.1c-2.9,0-3.5-1.8-3.6-1.9c-0.1-0.3,0.1-0.7,0.4-0.8c0.3-0.1,0.6,0.1,0.8,0.4c0,0.1,0.5,1.1,2.4,1.1
			c2,0,2.4-1.1,2.4-1.1c0.1-0.3,0.5-0.5,0.8-0.4c0.3,0.1,0.5,0.4,0.4,0.7C13.5,11.3,12.9,13.1,10,13.1z"
                        />
                    </g>
                </g>
                <path
                    fill="#A5A5A5"
                    stroke="#A5A5A5"
                    strokeWidth="0.25"
                    strokeMiterlimit="10"
                    d="M6.5,17.1c-0.4,0-0.7-0.1-1-0.3
	c-0.5-0.4-0.8-1-0.7-1.7l0.4-2.5C5.3,12.3,5.2,12,5,11.7L3.1,10C2.7,9.5,2.5,8.8,2.7,8.2C2.9,7.6,3.4,7.1,4.1,7l2.5-0.4
	c0.3,0,0.6-0.2,0.7-0.5l1.1-2.3c0.3-0.6,0.9-1,1.5-1c0.7,0,1.3,0.4,1.5,1l1.1,2.3c0.1,0.3,0.4,0.5,0.7,0.5L15.9,7
	c0.7,0.1,1.2,0.5,1.4,1.2c0.2,0.6,0,1.3-0.4,1.8l-1.8,1.8c-0.2,0.2-0.3,0.6-0.3,0.9l0.4,2.5c0.1,0.7-0.1,1.3-0.7,1.7
	c-0.5,0.4-1.2,0.4-1.8,0.1l-2.2-1.2c-0.3-0.1-0.6-0.1-0.9,0l-2.2,1.2C7,17.1,6.8,17.1,6.5,17.1z M10,3.7c-0.4,0-0.7,0.2-0.9,0.5
	L8,6.5C7.8,7,7.3,7.3,6.7,7.4L4.2,7.8C3.8,7.8,3.5,8.1,3.4,8.4c-0.1,0.4,0,0.7,0.2,1l1.8,1.8c0.4,0.4,0.6,1,0.5,1.5l-0.4,2.5
	c-0.1,0.4,0.1,0.7,0.4,1c0.3,0.2,0.7,0.2,1,0.1l2.2-1.2c0.5-0.3,1.1-0.3,1.6,0l2.2,1.2c0.3,0.2,0.7,0.1,1-0.1c0.3-0.2,0.5-0.6,0.4-1
	L14,12.7c-0.1-0.6,0.1-1.1,0.5-1.5l1.8-1.8c0.3-0.3,0.4-0.6,0.2-1c-0.1-0.4-0.4-0.6-0.8-0.7l-2.5-0.4c-0.6-0.1-1-0.4-1.3-0.9
	l-1.1-2.3C10.7,3.9,10.4,3.7,10,3.7z"
                />
            </svg>
        )}
    />
);

export const PageBackIcon = (props: any) => (
    <Icon
        {...props}
        component={() => (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="12" transform="rotate(-180 12 12)" fill="url(#paint0_linear_203_9399)" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.02789 11.1998L13.2 7.09091L12.0923 6L6 12L12.0923 18L13.2 16.9091L9.02749 12.7998L18 12.7998V11.1998L9.02789 11.1998Z"
                    fill="white"
                />
                <circle cx="12" cy="12" r="12" transform="rotate(-180 12 12)" fill="url(#paint1_linear_203_9399)" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.02789 11.1998L13.2 7.09091L12.0923 6L6 12L12.0923 18L13.2 16.9091L9.02749 12.7998L18 12.7998V11.1998L9.02789 11.1998Z"
                    fill="white"
                />
                <defs>
                    <linearGradient
                        id="paint0_linear_203_9399"
                        x1="0.875001"
                        y1="5.625"
                        x2="18.8164"
                        y2="7.93243"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#8590FF" />
                        <stop offset="1" stopColor="#A8A0FF" />
                    </linearGradient>
                    <linearGradient
                        id="paint1_linear_203_9399"
                        x1="2.66005"
                        y1="5.625"
                        x2="22.0706"
                        y2="10.589"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#9655FF" />
                        <stop offset="0.593333" stopColor="#A07DFF" />
                        <stop offset="1" stopColor="#A8A0FF" />
                    </linearGradient>
                </defs>
            </svg>
        )}
    />
);

export const FullScreen = ({ className, onClick }: IProps) => (
    <Icon
        className={className}
        onClick={onClick}
        component={() => (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.167 6.70835C13.5237 6.70835 13.8128 6.4192 13.8128 6.06251V2.83334C13.8128 2.66205 13.7448 2.49778 13.6237 2.37666C13.5026 2.25554 13.3383 2.1875 13.167 2.1875H9.93783C9.58114 2.1875 9.29199 2.47665 9.29199 2.83334C9.29199 3.19002 9.58114 3.47917 9.93783 3.47917H12.5212V6.06251C12.5212 6.4192 12.8103 6.70835 13.167 6.70835Z"
                    fill="#1B1B48"
                />
                <path
                    d="M8.64759 6.75593C8.89977 7.00811 9.30863 7.00812 9.56082 6.75595L12.9467 3.37029C13.199 3.11803 13.199 2.70903 12.9468 2.45677C12.6945 2.2045 12.2855 2.20451 12.0332 2.45678L8.64757 5.84271C8.3954 6.09489 8.39541 6.50376 8.64759 6.75593ZM2.64584 8.88267C2.28915 8.88267 2 9.17182 2 9.52851V12.7577C2 12.929 2.06804 13.0932 2.18916 13.2144C2.31028 13.3355 2.47455 13.4035 2.64584 13.4035H5.87501C6.2317 13.4035 6.52085 13.1144 6.52085 12.7577C6.52085 12.401 6.2317 12.1119 5.87501 12.1119H3.29167V9.52851C3.29167 9.17182 3.00252 8.88267 2.64584 8.88267Z"
                    fill="#1B1B48"
                />
                <path
                    d="M7.16463 8.8349C6.91245 8.58272 6.50359 8.58271 6.2514 8.83488L2.86548 12.2206C2.6132 12.4728 2.6132 12.8818 2.86546 13.1341C3.11772 13.3863 3.52672 13.3863 3.77898 13.1341L7.16464 9.74813C7.41681 9.49594 7.4168 9.08708 7.16463 8.8349Z"
                    fill="#1B1B48"
                />
            </svg>
        )}
    />
);

export const ExitFullScreen = ({ className, onClick }: IProps) => (
    <Icon
        className={className}
        onClick={onClick}
        component={() => (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.05078 12.9465C7.41897 12.9465 7.71745 12.648 7.71745 12.2798V8.94645C7.71745 8.76964 7.64721 8.60007 7.52219 8.47505C7.39716 8.35002 7.22759 8.27979 7.05078 8.27979H3.71745C3.34926 8.27979 3.05078 8.57826 3.05078 8.94645C3.05078 9.31464 3.34926 9.61312 3.71745 9.61312H6.38412V12.2798C6.38412 12.648 6.68259 12.9465 7.05078 12.9465Z"
                    fill="#1B1B48"
                />
                <path
                    d="M9.8623 2.1097C9.49411 2.1097 9.19564 2.40818 9.19564 2.77637V6.1097C9.19564 6.28651 9.26588 6.45608 9.3909 6.58111C9.51592 6.70613 9.68549 6.77637 9.8623 6.77637H13.1956C13.5638 6.77637 13.8623 6.47789 13.8623 6.1097C13.8623 5.74151 13.5638 5.44303 13.1956 5.44303H10.529V2.77637C10.529 2.40818 10.2305 2.1097 9.8623 2.1097Z"
                    fill="#1B1B48"
                />
                <path
                    d="M6.99722 9.02797C6.73691 8.76766 6.31486 8.76765 6.05454 9.02796L2.55941 12.5228C2.299 12.7832 2.29899 13.2054 2.55939 13.4658C2.81979 13.7262 3.24198 13.7262 3.50237 13.4658L6.99724 9.97066C7.25754 9.71033 7.25754 9.28829 6.99722 9.02797Z"
                    fill="#1B1B48"
                />
                <path
                    d="M9.66684 6.30503C9.92715 6.56535 10.3492 6.56535 10.6095 6.30505L14.1047 2.81018C14.3651 2.54979 14.3651 2.1276 14.1047 1.8672C13.8443 1.6068 13.4221 1.60681 13.1617 1.86722L9.66682 5.36235C9.40652 5.62267 9.40653 6.04472 9.66684 6.30503Z"
                    fill="#1B1B48"
                />
            </svg>
        )}
    />
);

export const NavigationNewCreateQuestionSvg = ({ className }: IProps) => (
    <Icon
        className={className}
        component={() => (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2.715 10C2.715 5.97661 5.97661 2.715 10 2.715C14.0234 2.715 17.285 5.97661 17.285 10C17.285 14.0234 14.0234 17.285 10 17.285H4.66667C3.58879 17.285 2.715 16.4112 2.715 15.3333V10Z"
                    stroke="#1B1B48"
                    strokeWidth="1.43"
                />
                <rect x="5.5" y="9.57129" width="8.57143" height="1.42857" rx="0.714286" fill="#1B1B48" />
                <rect
                    x="9.07129"
                    y="14.5713"
                    width="8.57143"
                    height="1.42857"
                    rx="0.714286"
                    transform="rotate(-90 9.07129 14.5713)"
                    fill="#1B1B48"
                />
            </svg>
        )}
    />
);

export const TitleSourceSvg = ({ className }: IProps) => (
    <Icon
        className={className}
        component={() => (
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.0034 0H1.99664C0.907563 0 0 0.878788 0 2V16C0 17.0909 0.877311 18 1.99664 18H16.0034C17.0924 18 18 17.1212 18 16V2C18 0.909091 17.0924 0 16.0034 0ZM16.3059 16C16.3059 16.0909 16.2756 16.1515 16.2151 16.2121C16.1546 16.2727 16.0941 16.303 16.0034 16.303H1.99664C1.90588 16.303 1.84538 16.2727 1.78487 16.2121C1.72437 16.1515 1.69412 16.0909 1.69412 16V2C1.69412 1.81818 1.84538 1.69697 1.99664 1.69697H16.0034C16.0941 1.69697 16.1546 1.72727 16.2151 1.78788C16.2756 1.84848 16.3059 1.90909 16.3059 2V16Z"
                    fill="#9655FF"
                    fillOpacity="0.35"
                />
                <path
                    d="M3 5.79152C3 6.07421 3.15363 6.32862 3.43017 6.46996C3.7067 6.61131 4.01397 6.61131 4.2905 6.46996C4.56704 6.32862 4.72067 6.07421 4.72067 5.79152C4.72067 5.36749 4.35196 5 3.86034 5C3.36872 5 3 5.36749 3 5.79152ZM13.1397 5H6.87151C6.41061 5 6.01117 5.33922 6.01117 5.79152C6.01117 6.21555 6.37989 6.58304 6.87151 6.58304H13.1397C13.6006 6.58304 14 6.24382 14 5.79152C14 5.36749 13.6006 5 13.1397 5ZM3 9.18375C3 9.46643 3.15363 9.72085 3.43017 9.86219C3.7067 10.0035 4.01397 10.0035 4.2905 9.86219C4.56704 9.72085 4.72067 9.46643 4.72067 9.18375C4.72067 8.75972 4.35196 8.39223 3.86034 8.39223C3.36872 8.39223 3 8.73145 3 9.18375ZM13.1397 8.39223H6.87151C6.56425 8.39223 6.28771 8.53357 6.13408 8.78799C5.98045 9.0424 5.98045 9.32509 6.13408 9.5795C6.28771 9.83392 6.56425 9.97527 6.87151 9.97527H13.1397C13.6006 9.97527 14 9.63604 14 9.18375C14 8.73145 13.6006 8.39223 13.1397 8.39223ZM3 12.2085C3 12.4912 3.15363 12.7456 3.43017 12.8869C3.7067 13.0283 4.01397 13.0283 4.2905 12.8869C4.56704 12.7456 4.72067 12.4912 4.72067 12.2085C4.72067 11.7845 4.35196 11.417 3.86034 11.417C3.36872 11.417 3 11.7562 3 12.2085ZM13.1397 11.417H6.87151C6.41061 11.417 6.01117 11.7562 6.01117 12.2085C6.01117 12.6608 6.37989 13 6.87151 13H13.1397C13.6006 13 14 12.6608 14 12.2085C14 11.7562 13.6006 11.417 13.1397 11.417Z"
                    fill="#9655FF"
                    fillOpacity="0.35"
                />
            </svg>
        )}
    />
);

export const VideoSourceSvg = ({ className }: IProps) => (
    <Icon
        className={className}
        component={() => (
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15 0C15.7956 0 16.5587 0.31607 17.1213 0.87868C17.6839 1.44129 18 2.20435 18 3V15C18 15.7956 17.6839 16.5587 17.1213 17.1213C16.5587 17.6839 15.7956 18 15 18H3C2.20435 18 1.44129 17.6839 0.87868 17.1213C0.31607 16.5587 0 15.7956 0 15V3C0 2.20435 0.31607 1.44129 0.87868 0.87868C1.44129 0.31607 2.20435 0 3 0H15ZM15 1.5H3C2.62157 1.49988 2.25708 1.6428 1.97959 1.90012C1.7021 2.15744 1.53213 2.51013 1.50375 2.8875L1.5 3V15C1.49988 15.3784 1.6428 15.7429 1.90012 16.0204C2.15744 16.2979 2.51013 16.4679 2.8875 16.4963L3 16.5H15C15.3784 16.5001 15.7429 16.3572 16.0204 16.0999C16.2979 15.8426 16.4679 15.4899 16.4963 15.1125L16.5 15V3C16.5001 2.62157 16.3572 2.25708 16.0999 1.97959C15.8426 1.7021 15.4899 1.53213 15.1125 1.50375L15 1.5ZM6.867 4.713C7.0705 4.71319 7.27183 4.75478 7.45875 4.83525L7.59525 4.90275L12.6112 7.689C12.8346 7.81322 13.0225 7.99245 13.1572 8.20968C13.2918 8.42691 13.3687 8.67494 13.3806 8.93023C13.3924 9.18553 13.3389 9.43963 13.225 9.66841C13.1111 9.8972 12.9406 10.0931 12.7297 10.2375L12.6112 10.311L7.59525 13.0972C7.37824 13.2177 7.13475 13.2824 6.88659 13.2855C6.63844 13.2887 6.39337 13.2302 6.17336 13.1154C5.95335 13.0006 5.76527 12.8329 5.62598 12.6275C5.48669 12.4221 5.40054 12.1854 5.37525 11.9385L5.367 11.7863V6.21375C5.367 5.81593 5.52503 5.43439 5.80634 5.15309C6.08764 4.87179 6.46918 4.71375 6.867 4.71375V4.713ZM6.867 6.213V11.7863L11.883 9L6.867 6.213Z"
                    fill="#9655FF"
                    fillOpacity="0.35"
                />
            </svg>
        )}
    />
);

export const JumpLinkOfQuestionSourceSvg = ({ className }: IProps) => (
    <Icon
        className={className}
        component={() => (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 10C20 4.47715 15.5228 -1.51594e-06 10 -1.03312e-06C4.47715 -5.50298e-07 5.50298e-07 4.47715 1.03312e-06 10C1.51594e-06 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10Z"
                    fill="#9655FF"
                    fillOpacity="0.08"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.4076 14.714C8.14725 14.4537 8.14725 14.0316 8.4076 13.7712L12.1788 9.99998L8.4076 6.22874C8.14725 5.96839 8.14725 5.54628 8.4076 5.28593C8.66795 5.02558 9.09006 5.02558 9.35041 5.28593L13.3573 9.29287C13.7479 9.68339 13.7479 10.3166 13.3573 10.7071L9.35041 14.714C9.09006 14.9744 8.66795 14.9744 8.4076 14.714Z"
                    fill="#1B1B48"
                    fillOpacity="0.85"
                />
            </svg>
        )}
    />
);

export const QSvg = ({ className }: IProps) => (
    <Icon
        className={className}
        component={() => (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M0.500003 8.22857C0.500003 5.21293 0.934207 3.32874 1.98288 2.17897C3.0195 1.04241 4.77448 0.500001 7.77143 0.500001C10.7939 0.500001 12.6685 0.908659 13.8145 1.99193C14.9534 3.06846 15.5 4.93589 15.5 8.22857C15.5 11.5262 14.9512 13.2614 13.8325 14.2204C12.69 15.2 10.8168 15.5 7.77143 15.5C4.75101 15.5 2.99761 15.0636 1.96701 14.033C0.936413 13.0024 0.500002 11.249 0.500003 8.22857Z"
                    stroke="#D4C9FF"
                />
                <path
                    d="M7.7408 3.74878C8.30827 3.74878 8.80107 3.85704 9.2192 4.07358C9.6448 4.29011 9.99573 4.58504 10.272 4.95838C10.5557 5.32424 10.7685 5.75358 10.9104 6.24638C11.0523 6.73918 11.1232 7.25811 11.1232 7.80318C11.1232 8.25118 11.0784 8.68424 10.9888 9.10238C10.8992 9.51304 10.7461 9.90878 10.5296 10.2896L11.0896 10.8496C11.3957 11.1557 11.448 11.417 11.2464 11.6336C11.1643 11.7381 11.056 11.7829 10.9216 11.768C10.7947 11.7605 10.6453 11.6709 10.4736 11.4992L9.9808 11.0176C9.6672 11.3013 9.3312 11.5141 8.9728 11.656C8.6144 11.7978 8.20373 11.8688 7.7408 11.8688C7.1808 11.8688 6.688 11.7605 6.2624 11.544C5.8368 11.3274 5.48213 11.0362 5.1984 10.6704C4.92213 10.297 4.71307 9.86398 4.5712 9.37118C4.42933 8.87838 4.3584 8.35571 4.3584 7.80318C4.3584 7.25811 4.4256 6.73918 4.56 6.24638C4.6944 5.75358 4.89973 5.32424 5.176 4.95838C5.45973 4.58504 5.8144 4.29011 6.24 4.07358C6.6656 3.85704 7.16587 3.74878 7.7408 3.74878ZM7.7408 11.0624C8.0768 11.0624 8.3792 11.0138 8.648 10.9168C8.92427 10.8122 9.1744 10.648 9.3984 10.424L8.6032 9.62878C8.40907 9.46451 8.42027 9.26291 8.6368 9.02398C8.7264 8.93438 8.82347 8.87838 8.928 8.85598C9.04 8.82611 9.14453 8.87091 9.2416 8.99038L9.9136 9.67358C10.0331 9.37491 10.1189 9.08371 10.1712 8.79998C10.2235 8.50878 10.2496 8.18771 10.2496 7.83678C10.2496 7.40371 10.2011 6.98931 10.104 6.59358C10.0069 6.19784 9.85387 5.84691 9.6448 5.54078C9.4432 5.23464 9.18187 4.99198 8.8608 4.81278C8.5472 4.62611 8.17387 4.53278 7.7408 4.53278C7.30027 4.53278 6.9232 4.62611 6.6096 4.81278C6.296 4.99198 6.03467 5.23464 5.8256 5.54078C5.624 5.83944 5.47467 6.18664 5.3776 6.58238C5.28053 6.97064 5.232 7.37758 5.232 7.80318C5.232 8.22131 5.28053 8.62451 5.3776 9.01278C5.47467 9.40104 5.624 9.74824 5.8256 10.0544C6.0272 10.3605 6.2848 10.6069 6.5984 10.7936C6.91947 10.9728 7.30027 11.0624 7.7408 11.0624Z"
                    fill="#D4C9FF"
                />
            </svg>
        )}
    />
);

export const SearchSvg = ({ className }: IProps) => (
    <Icon
        className={className}
        component={() => (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.74219 7.55737C1.74219 4.6866 4.06941 2.35938 6.94019 2.35938C9.81096 2.35938 12.1382 4.6866 12.1382 7.55737C12.1382 10.4281 9.81096 12.7554 6.94019 12.7554C4.06941 12.7554 1.74219 10.4281 1.74219 7.55737ZM6.94019 1.35938C3.51713 1.35938 0.742188 4.13431 0.742188 7.55737C0.742188 10.9804 3.51713 13.7554 6.94019 13.7554C8.51453 13.7554 9.95179 13.1684 11.045 12.2013L14.39 15.8385C14.5769 16.0417 14.8932 16.055 15.0965 15.868C15.2997 15.6811 15.313 15.3648 15.126 15.1615L11.7725 11.5151C11.7615 11.5031 11.7501 11.4918 11.7382 11.4812C12.6132 10.4125 13.1382 9.04627 13.1382 7.55737C13.1382 4.13431 10.3632 1.35938 6.94019 1.35938Z"
                    fill="#1B1B48"
                    fillOpacity="0.85"
                />
            </svg>
        )}
    />
);

export const DownwardSvg = ({ className }: IProps) => (
    <Icon
        className={className}
        component={() => (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.1384 5.34315C3.39875 5.0828 3.82086 5.0828 4.08121 5.34315L7.85244 9.11438L11.6237 5.34314C11.884 5.0828 12.3061 5.0828 12.5665 5.34315C12.8268 5.6035 12.8268 6.0256 12.5665 6.28595L8.55955 10.2929C8.16902 10.6834 7.53586 10.6834 7.14534 10.2929L3.1384 6.28595C2.87805 6.02561 2.87805 5.6035 3.1384 5.34315Z"
                    fill="#9655FF"
                />
            </svg>
        )}
    />
);

export const ReplaceEveryoneIsAskSvg = ({ className }: IProps) => (
    <Icon
        className={className}
        component={() => (
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_84_699)">
                    <path
                        d="M10.2499 2.91734C9.29592 1.60433 7.74802 0.75 5.99987 0.75C3.2867 0.75 1.05479 2.80771 0.778588 5.448L0.726562 5.94525L1.72114 6.0493L1.77316 5.552C1.99665 3.41563 3.80407 1.75 5.99987 1.75C7.52022 1.75 8.85497 2.54844 9.60622 3.75H8.24987C7.97372 3.75 7.74987 3.97386 7.74987 4.25C7.74987 4.52614 7.97373 4.75 8.24987 4.75H10.7671C11.0337 4.75 11.2499 4.53386 11.2499 4.26724V1.75C11.2499 1.47386 11.026 1.25 10.7499 1.25C10.4737 1.25 10.2499 1.47386 10.2499 1.75V2.91734ZM10.2786 5.9507L10.2266 6.448C10.0031 8.58435 8.19567 10.25 5.99987 10.25C4.47952 10.25 3.14478 9.45155 2.39351 8.25H3.74987C4.02601 8.25 4.24987 8.02614 4.24987 7.75C4.24987 7.47386 4.02601 7.25 3.74987 7.25H1.27161C0.983458 7.25 0.749867 7.48359 0.749867 7.77174V10.25C0.749867 10.5261 0.973725 10.75 1.24987 10.75C1.52601 10.75 1.74987 10.5261 1.74987 10.25V9.08265C2.70384 10.3957 4.25171 11.25 5.99987 11.25C8.71302 11.25 10.945 9.1923 11.2212 6.552L11.2732 6.05475L10.2786 5.9507Z"
                        fill="#1B1B48"
                        fillOpacity="0.65"
                    />
                </g>
            </svg>
        )}
    />
);

export const EveryoneIsAskItemIconSvg = ({ className }: IProps) => (
    <Icon
        className={className}
        component={() => (
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.69636 3.02319C6.80044 2.74191 7.19827 2.74191 7.30236 3.02319L8.34925 5.85238C8.38198 5.94081 8.4517 6.01054 8.54013 6.04326L11.3693 7.09016C11.6506 7.19424 11.6506 7.59207 11.3693 7.69615L8.54013 8.74305C8.4517 8.77577 8.38198 8.8455 8.34925 8.93393L7.30236 11.7631C7.19827 12.0444 6.80044 12.0444 6.69636 11.7631L5.64946 8.93393C5.61674 8.8455 5.54702 8.77577 5.45858 8.74305L2.62939 7.69615C2.34811 7.59207 2.34811 7.19424 2.62939 7.09016L5.45858 6.04326C5.54702 6.01054 5.61674 5.94081 5.64946 5.85238L6.69636 3.02319Z"
                    stroke="#1B1B48"
                    strokeOpacity="0.65"
                />
            </svg>
        )}
    />
);

export const ArrowMoreSvg = ({ className }: IProps) => (
    <Icon
        className={className}
        component={() => (
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.46723 2.07335C6.46722 2.16251 6.48477 2.25081 6.51888 2.33319C6.55299 2.41557 6.603 2.49042 6.66604 2.55347C6.72909 2.61653 6.80394 2.66655 6.88631 2.70067C6.96869 2.73479 7.05698 2.75236 7.14614 2.75236C7.23531 2.75236 7.3236 2.73479 7.40597 2.70067C7.48835 2.66655 7.5632 2.61653 7.62624 2.55347C7.68929 2.49042 7.73929 2.41557 7.77341 2.33319C7.80752 2.25081 7.82507 2.16251 7.82506 2.07335C7.82503 1.8933 7.75349 1.72065 7.62617 1.59335C7.49885 1.46605 7.32619 1.39453 7.14614 1.39453C6.9661 1.39453 6.79343 1.46605 6.66611 1.59335C6.53879 1.72065 6.46726 1.8933 6.46723 2.07335ZM7.14614 9.84594C7.23538 9.84594 7.32373 9.82835 7.40616 9.79417C7.48859 9.76 7.56348 9.70991 7.62653 9.64677C7.68959 9.58363 7.73957 9.50868 7.77364 9.4262C7.8077 9.34373 7.82518 9.25535 7.82506 9.16611V4.78991C7.82507 4.70075 7.80752 4.61246 7.77341 4.53008C7.73929 4.44769 7.68929 4.37284 7.62624 4.30979C7.5632 4.24673 7.48835 4.19672 7.40597 4.16259C7.3236 4.12847 7.23531 4.1109 7.14614 4.1109C7.05698 4.1109 6.96869 4.12847 6.88631 4.16259C6.80394 4.19672 6.72909 4.24673 6.66604 4.30979C6.603 4.37284 6.55299 4.44769 6.51888 4.53008C6.48477 4.61246 6.46722 4.70075 6.46723 4.78991V9.16611C6.46723 9.54116 6.7711 9.84594 7.14614 9.84594ZM6.7784 13.1614C6.82685 13.2073 6.88524 13.2414 6.94903 13.261C7.01281 13.2806 7.08027 13.2852 7.14614 13.2745C7.21201 13.2852 7.27947 13.2806 7.34326 13.261C7.40705 13.2414 7.46544 13.2073 7.51389 13.1614L11.7845 8.83602C11.9798 8.63709 11.9214 8.25657 11.654 7.98555C11.3866 7.71454 11.0107 7.65522 10.8145 7.85324L7.14614 11.5699L3.47782 7.85324C3.28254 7.65522 2.90658 7.71362 2.6383 7.98555C2.37093 8.25657 2.31253 8.63709 2.50872 8.83511L6.7784 13.1614Z"
                    fill="#6C77FF"
                />
            </svg>
        )}
    />
);

export const GouxuankuangSvg = ({ className }: IProps) => (
    <Icon
        className={className}
        component={() => (
            <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3718" width="200" height="200">
                <path
                    d="M768 85.333333a170.666667 170.666667 0 0 1 170.666667 170.666667v512a170.666667 170.666667 0 0 1-170.666667 170.666667H256a170.666667 170.666667 0 0 1-170.666667-170.666667V256a170.666667 170.666667 0 0 1 170.666667-170.666667h512zM256 0a256 256 0 0 0-256 256v512a256 256 0 0 0 256 256h512a256 256 0 0 0 256-256V256a256 256 0 0 0-256-256H256z"
                    fill="#000000"
                    fill-opacity=".25"
                    p-id="3719"
                ></path>
            </svg>
        )}
    />
);

export const AgreeSvg = ({ className }: IProps) => (
    <Icon
        className={className}
        component={() => (
            <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3863" width="200" height="200">
                <path
                    d="M0 0m256 0l512 0q256 0 256 256l0 512q0 256-256 256l-512 0q-256 0-256-256l0-512q0-256 256-256Z"
                    fill="#FFA431"
                    p-id="3864"
                ></path>
                <path
                    d="M425.386667 701.354667a30.976 30.976 0 0 0 45.226666 0l316.416-331.349334a34.56 34.56 0 0 0 0-47.274666 30.976 30.976 0 0 0-45.226666 0L448.085333 630.272 282.197333 456.533333a30.976 30.976 0 0 0-45.226666 0 34.56 34.56 0 0 0 0 47.274667L425.386667 701.44z"
                    fill="#FFFFFF"
                    p-id="3865"
                ></path>
            </svg>
        )}
    />
);
